import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { AllProducts } from 'features/ECommerce/screens/AllProducts'
import Script from 'next/script'

export default function RecipesPage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Products - We Feed Raw',
    url: 'https://wefeedraw.com/products',
    description: 'Explore Our Premium Raw Dog Food Products | We Feed Raw',
    numberOfItems: 9,
    itemListElement: [
      {
        '@type': 'Product',
        name: 'Large Box of Premium Raw Dog Food | We Feed Raw',
        url: 'https://wefeedraw.com/products/big-box',
        image: 'https://wefeedraw.com/assets/e-commerce-big-box.webp',
        description: 'Discover our large box of premium raw dog food, perfect for convenient, high-quality nutrition. Ideal for medium-to-large dogs (50 lbs or more), our big box offers a balanced diet with the best ingredients. Shop now at We Feed Raw.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/big-box',
          priceCurrency: 'USD',
          price: '264.00',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: 'Classic Box of Premium Raw Dog Food | We Feed Raw',
        url: 'https://wefeedraw.com/products/classic-box',
        image: 'https://wefeedraw.com/assets/e-commerce-classic-box.webp',
        description: 'Discover our classic box of premium raw dog food, perfect for convenient, high-quality nutrition. Ideal for medium dogs, our classic box offers a balanced diet with the best ingredients. Shop now at We Feed Raw.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/classic-box',
          priceCurrency: 'USD',
          price: '199.00',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: 'Small Box of Premium Raw Dog Food | We Feed Raw',
        url: 'https://wefeedraw.com/products/small-box',
        image: 'https://wefeedraw.com/assets/e-commerce-small-box.webp',
        description: 'Discover our small box of premium raw dog food, perfect for convenient, high-quality nutrition. Ideal for small dogs (or as a taste-test for larger dogs), our small box offers a balanced diet with the best ingredients. Shop now at We Feed Raw.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/small-box',
          priceCurrency: 'USD',
          price: '132.00',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5 lb Venison Patty Raw Pet Food Recipe | We Feed Raw',
        url: 'https://wefeedraw.com/products/5-lb-venison-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-venison.webp',
        description: 'Enhance your dog\'s diet with our 5 lb Raw Venison Patty. Packed with high-quality venison meat, organs and ground bones, this recipe promotes optimal health and vitality. Perfect for a balanced, nutritious meal. Shop now at We Feed Raw!',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-venison-patty-recipe',
          priceCurrency: 'USD',
          price: '49.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5 lb Lamb Patty Raw Pet Food Recipe | We Feed Raw',
        url: 'https://wefeedraw.com/products/5-lb-lamb-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-lamb.webp',
        description: 'Enhance your dog\'s diet with our 5 lb Lamb Patty. Packed with high-quality lamb meat, organs and ground bones, this recipe promotes optimal health and vitality. Perfect for a balanced, nutritious meal. Shop now at We Feed Raw!',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-lamb-patty-recipe',
          priceCurrency: 'USD',
          price: '47.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5 lb Duck Patty Raw Pet Food Recipe | We Feed Raw',
        url: 'https://wefeedraw.com/products/5-lb-duck-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-duck.webp',
        description: 'Complete & Balanced nutrition for dogs of all life stages.',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-duck-patty-recipe',
          priceCurrency: 'USD',
          price: '47.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5 lb Turkey Patty Raw Pet Food Recipe | We Feed Raw',
        url: 'https://wefeedraw.com/products/5-lb-turkey-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-turkey.webp',
        description: 'Enhance your dog\'s diet with our 5 lb Raw Turkey Patty. Packed with high-quality turkey meat, organs and ground bones, this recipe promotes optimal health and vitality. Perfect for a balanced, nutritious meal. Shop now at We Feed Raw!',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-turkey-patty-recipe',
          priceCurrency: 'USD',
          price: '42.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5 lb Beef Patty Raw Pet Food Recipe | We Feed Raw',
        url: 'https://wefeedraw.com/products/5-lb-beef-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-beef.webp',
        description: 'Enhance your dog\'s diet with our 5 lb Raw Beef Patty. Packed with high-quality beef meat, organs and ground bones, this recipe promotes optimal health and vitality. Perfect for a balanced, nutritious meal. Shop now at We Feed Raw!',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-beef-patty-recipe',
          priceCurrency: 'USD',
          price: '42.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      },
      {
        '@type': 'Product',
        name: '5 lb Chicken Patty Raw Pet Food Recipe | We Feed Raw',
        url: 'https://wefeedraw.com/products/5-lb-chicken-patty-recipe',
        image: 'https://wefeedraw.com/assets/e-commerce-chicken.webp',
        description: 'Enhance your dog\'s diet with our 5 lb Raw Chicken Patty. Packed with high-quality chicken meat, organs and ground bones, this recipe promotes optimal health and vitality. Perfect for a balanced, nutritious meal. Shop now at We Feed Raw!',
        brand: {
          '@type': 'Brand',
          name: 'We Feed Raw'
        },
        offers: {
          '@type': 'Offer',
          url: 'https://wefeedraw.com/products/5-lb-chicken-patty-recipe',
          priceCurrency: 'USD',
          price: '37.99',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD'
            },
            shippingDestination: {
              '@type': 'DefinedRegion',
              name: 'Worldwide'
            }
          }
        }
      }
    ]
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('products:meta.page-title')}</title>
        <meta name="title" content={t('products:meta.title')} />
        <meta name="description" content={t('products:meta.description')} />
        <link rel="canonical" href="https://wefeedraw.com/products" />
      </Head>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />

      <AllProducts />
    </>
  )
}
